/* eslint-disable */
import React, { useEffect } from "react";
import { getTransactions } from "../../../actions/appExpandedActions/finances";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const Transactions = ({ getTransactions, transactions, period }) => {
  // Initial load
  useEffect(() => {
    getTransactions({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support both new PeriodSelector and legacy formats
  useEffect(() => {
    // For "All time" (both null), send empty strings
    if (!period?.startDate && !period?.endDate) {
      getTransactions({
        page: 1,
        limit: 20,
        startDate: "",
        endDate: ""
      });
    } else if (period?.startDate) {
      // For specific periods, send the actual dates
      getTransactions({
        page: 1,
        limit: 20,
        startDate: period?.startDate || "",
        endDate: period?.endDate || "",
      });
    }
  }, [period]);

  const handleLoadMore = (page) => {
    // Use the same logic for load more
    const payload = {
      page,
      limit: 20
    };
    
    if (!period?.startDate && !period?.endDate) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate) {
      payload.startDate = period?.startDate || "";
      payload.endDate = period?.endDate || "";
    }
    
    getTransactions(payload);
  };

  return (
    <DataTable
      {...tablePresets.transactions}
      data={transactions}
      fetchData={getTransactions}
      period={period}
      onLoadMore={handleLoadMore}
    />
  );
};

const mapStateToProps = (state) => ({
  transactions: state.appFinances.transactions,
});

const mapDispatchToProps = (dispatch) => ({
  getTransactions: (payload) => dispatch(getTransactions(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);